import script from "./ArticleReader.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleReader.vue?vue&type=script&setup=true&lang=js"

import "./ArticleReader.vue?vue&type=style&index=0&id=792b65a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-792b65a3"]])

export default __exports__